// utils
import get from 'lodash.get';

// constants
import { PATHS } from '~/constants';

// types
import type { CardsBlogProps } from '~/components/redesign/Cards/Blog.vue';

export default function convertArticleToCardsBlogProps(
  article: unknown = {},
): CardsBlogProps {
  const slug = get(article, 'slug');

  return {
    image: {
      src: get(article, 'data.data.preview_picture_url'),
      alt: 'Article preview image',
    },
    tag: {
      slug: get(article, 'categories[0].slug'),
      name: get(article, 'categories[0].data.title'),
    },
    part: get(article, 'data.data.post_subtitle'),
    title: get(article, 'data.title'),
    author: get(article, 'authors[0].data.name'),
    publishedAt: get(article, 'publish_at'),
    timeToRead: get(article, 'data.data.preview_time_to_read'),

    slug,
    type: get(article, 'type'),
    status: get(article, 'status'),
    categories: get(article, 'categories'),
  };
}
